import React from "react";
import { Container, Typography, Box, Grid, Card, CardActionArea, CardContent, CardMedia } from "@mui/material";

const storeLocations = [
  {
    name: "Tampa",
    image: "https://jaseljewelry.com/cdn/shop/files/IMG_3354.jpg?v=1726591791", // Replace with actual image URL
    link: "https://jaseljewelry.com/pages/tampa-appointments",
  },
  {
    name: "Orlando",
    image: "https://jaseljewelry.com/cdn/shop/files/IMG_7557.jpg?v=1717534606", // Replace with actual image URL
    link: "https://jaseljewelry.com/products/jasel-orlando-permanent-jewelry",
  },
  {
    name: "Piercing",
    image: "https://jaseljewelry.com/cdn/shop/files/IMG_7409.jpg?v=1734107507", // Replace with actual image URL
    link: "https://jaseljewelry.com/pages/make-piercing-appointment",
  },
];

const Home = () => {
  return (
    <Container maxWidth="lg">
      {/* Hero Section with Background Image */}
      <Box
        sx={{
          position: "relative",
          textAlign: "center",
          height: "500px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          borderRadius: 3,
          overflow: "hidden",
          mb: 6,
        }}
      >
        {/* Background Image */}
        <Box
          sx={{
            position: "absolute",
            top: "20%", // Moves the image down
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: `url('https://jaseljewelry.com/cdn/shop/files/Screen_Shot_2023-06-19_at_10.19.48_PM.png?v=1687227751')`,
            backgroundSize: "cover",
            backgroundPosition: "center bottom",
            filter: "brightness(50%)",
            zIndex: -1,
          }}
        />

        {/* Hero Text */}
        <Box sx={{ position: "relative", zIndex: 1, px: 3 }}>
          <Typography variant="h3" fontWeight="bold" gutterBottom>
            Welcome to Jasel
          </Typography>
        </Box>
      </Box>

      {/* Store Locations Section */}
      <Box sx={{ textAlign: "center", mt: 6 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Our Store Locations
        </Typography>
      </Box>

      <Grid container spacing={4} sx={{ mt: 2 }}>
        {storeLocations.map((store, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
              <CardActionArea component="a" href={store.link} target="_blank">
                <CardMedia
                  component="img"
                  height="250"
                  image={store.image}
                  alt={store.name}
                />
                <CardContent sx={{ textAlign: "center", bgcolor: "#f5f5f5" }}>
                  <Typography variant="h6" fontWeight="bold">
                    {store.name}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Home;
